// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__EsQNR","autoComplete":"SearchBar_autoComplete__4TvXT","autoCompleteSuggestion":"SearchBar_autoCompleteSuggestion__uRlz+"};